import { createFileRoute } from "@tanstack/react-router";
import { DisplayNativeAdsServicePage } from "./services_.display-native-ads";

export const Route = createFileRoute("/services_/display-native-ads-services")({
  head: () => ({
    meta: [
      {
        title: "Display & Native Ads Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "High-Impact Rich Media Display & Contextual Native Ads.",
      },
    ],
  }),
  component: DisplayNativeAdsServicePage,
});
